import Furigana from '@components/furigana';
import * as React from 'react';
export default {
  Furigana,
  React
};